import { useContext } from "react";
import { useState, useEffect } from "react";
import { createContext } from "react";

export const MySuccessContext = createContext();

export default function SuccessContext({ children }) {
  const [successStatus, setSuccessStatus] = useState(false);
  const [sucessTitle, setSucessTitle] = useState('');

  return (
    <MySuccessContext.Provider
      value={{
        successStatus,
        setSuccessStatus,
        sucessTitle,
        setSucessTitle,
      }}
    >
      {children}
    </MySuccessContext.Provider>
  );
}

export const useSuccess = () => {
  return useContext(MySuccessContext);
};
